import { c as _c } from "react/compiler-runtime";
import SettingConfig from '@module/config/setting';
import type { NormalChatMessage } from '@module/types/centrifuge/public-message/normalChatMessageTypes';
interface Props {
  type: NormalChatMessage['data']['sex'];
  enabledUnknown?: boolean;
  className?: string;
}
function ChatGenderPrefixImage(t0) {
  const $ = _c(6);
  const {
    type,
    enabledUnknown: t1,
    className
  } = t0;
  const enabledUnknown = t1 === undefined ? false : t1;
  if (type === "M") {
    let t2;
    if ($[0] !== className) {
      t2 = <img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/gender/ico_live_gender_male.png`} alt="male" className={className} crossOrigin="anonymous" />;
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (type === "F") {
    let t2;
    if ($[2] !== className) {
      t2 = <img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/gender/ico_live_gender_female.png`} alt="female" className={className} crossOrigin="anonymous" />;
      $[2] = className;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (enabledUnknown) {
    let t2;
    if ($[4] !== className) {
      t2 = <img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/gender/ico_live_gender_unknown.png`} alt="unknown" className={className} crossOrigin="anonymous" />;
      $[4] = className;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  return null;
}
export default ChatGenderPrefixImage;